const trigger = document.getElementById("popoverTrigger");
const popover = document.getElementById("popoverContent");
const closeBtn = document.getElementById("closePopover");
const closeOkBtn = document.getElementById("closePopover2");

function openPopover() {
  popover.classList.add("show");
  trigger.setAttribute("aria-expanded", "true");
  closeOkBtn.focus(); // Optionally move focus inside
}

function closePopover() {
  popover.classList.remove("show");
  trigger.setAttribute("aria-expanded", "false");
  trigger.focus(); // Return focus to the trigger
}

// Toggle on button click
trigger.addEventListener("click", () => {
  const isOpen = popover.classList.contains("show");
  if (!isOpen) {
    openPopover();
  } else {
    closePopover();
  }
});

// Close on "Close" button
closeBtn.addEventListener("click", closePopover);
closeOkBtn.addEventListener("click", closePopover);

// Close on Escape key
document.addEventListener("keydown", (e) => {
  if (e.key === "Escape" && popover.classList.contains("show")) {
    closePopover();
  }
});

// Optional: Close if user clicks outside
document.addEventListener("mousedown", (e) => {
  if (!popover.contains(e.target) && e.target !== trigger) {
    closePopover();
  }
});

// POPOVER SHORTCUTS

// Summary Panel Shortcuts

// Listen for a specific keyboard shortcut (e.g., Ctrl + Alt + P)
document.addEventListener("keydown", (event) => {
  // Check if Ctrl and Alt are both pressed and the pressed key is "p"
  if (event.shiftKey && event.key.toLowerCase() === "w") {
    // Prevent default behavior (optional, if needed)
    event.preventDefault();
    openPopover();
  }
});
